// @ts-strict-ignore
import { createSlice } from '@reduxjs/toolkit';
import reducerFnsByActionType from './reducerFnsByActionType';
import { initialState } from './state';

export const applicationPageSlice = createSlice({
  initialState,
  name: 'applicationPage',
  reducers: reducerFnsByActionType,
});

export const {
  mergeApplicationData,
  mergePrimaryApplicationData,
  mergeSecondaryApplicationData,
  resetToInitialState,
  setCompletedCaseByCaseToken,
  setEntityData,
  setEntityDocumentsByDocToken,
  setEvaluationByEvaluationToken,
  setNotes,
  setSelectedJourneyApplicationStep,
} = applicationPageSlice.actions;

export default applicationPageSlice.reducer;
